export enum OrganizationTypes {
    Corp = 1,
    Region = 2,
    Market = 3,
    Store = 4,
    BusinessLine = 5,
    Hospital = 6,
    State= 7,
    PricingTier = 8

}
